module.exports = "pegasus/assets/tech/realty/105.png";